import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RoundCard, RunnerUpHeader } from "../../../ui";
import { ALERT_TYPE_INFO, FINALIZE_EPB } from "../../../constants/constants";
import { useDownloadEpbMutation } from "../../../services/epbAndEpbPinService";
import { useEffect } from "react";
import { useGetObjectStoreFileQuery, useSubmitObjectStoreUploadMutation } from "../../../services/objectStoreServices";
import { parseJwt } from "../../utilities/utils";
import {
  useGetEpbDetailQuery,
  useGetServiceVoterCountQuery,
  useSaveEPbPaperFileMutation,
} from "../../../services/finalizeGenerateViewTransmitService";
import CustomModal from "../../../library/components/Modal/modal";
import ConfirmationModal from "../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import { createAlert } from "../../../features/alert/alerts";
import { useDispatch } from "react-redux";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const Finalizeepb = ({ refetch }) => {
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [ballot, datap] = useDownloadEpbMutation();
  const dispatch = useDispatch();
  const [pdf, setpdf] = useState("");
  const [uploadBallot, datac] = useSubmitObjectStoreUploadMutation();
  const [FinalizeBallot, dataf] = useSaveEPbPaperFileMutation();
  const { data: getEpbDetails, isSuccess } = useGetEpbDetailQuery();
  const { data: AcWiseVoterData } = useGetServiceVoterCountQuery()
  const { data: fileObject ,isSuccess:getFile } = useGetObjectStoreFileQuery(
    getEpbDetails?.payload?.epbPaperPath,
    { skip: (getEpbDetails?.payload?.epbPaperPath ==="" ||getEpbDetails?.payload?.epbPaperPath ===undefined ||getEpbDetails?.payload?.epbPaperPath ===null ) }
  );

  useEffect(() => {
    if ((getEpbDetails?.payload?.epbPaperPath ==="" ||getEpbDetails?.payload?.epbPaperPath ===undefined ||getEpbDetails?.payload?.epbPaperPath ===null ) && isSuccess && AcWiseVoterData) {
      ballot({
        id: [],
        isDummy: "true",
        constType: parseJwt(localStorage?.access_token)?.constituencyType,
        electionType: AcWiseVoterData?.electionType,
        officerId: parseJwt(localStorage?.access_token)?.preferred_username,
      })
      ;
    }
  }, [getEpbDetails,AcWiseVoterData]);

  useEffect(() => {
    if (fileObject && getFile) {
      const blob = base64ToBlob(fileObject.file, "application/pdf");
      if (blob) {
        const url = URL.createObjectURL(blob);
        setpdf(url);
      }
    }
  }, [fileObject]);

  const base64ToBlob = (base64, type = "application/octet-stream") => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  useEffect(() => {
    if (datap.isSuccess) {
      setpdf(URL.createObjectURL(datap?.data));
    }
    if(datap.isSuccess && datap?.data?.size==0){
      onInfo("Please Upload the ballot paper first")
    }
  }, [datap.isSuccess]);


  let constType = parseJwt(localStorage.access_token)?.constituencyType;
  let userState = parseJwt(localStorage.access_token)?.authorizedStates?.[0];
  let userAc =
    constType === "AC"
      ? parseJwt(localStorage.access_token)?.authorizedAcs?.[0]
      : parseJwt(localStorage.access_token)?.authorizedPcs?.[0];

  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };


  const finalizeEpb = () => {
    urltoFile(
      URL.createObjectURL(datap?.data),
      "ballot.pdf",
      "application/pdf"
    ).then((file) => {
      let formdata = new FormData();
      formdata.append("bucketName", "");
      formdata.append("file", file);
      formdata.append("fileType", file?.type);
      formdata.append("fileName", file?.name);
      formdata.append("stateCode", userState);
      formdata.append("acNo", `${constType}${userAc}`);
      formdata.append("type", `ETPBMS_DUMMY`);
      if (formdata !== null && formdata !== {}) {
        uploadBallot(formdata).then((res) => {
          FinalizeBallot({
            id: 14,
            ballotpaperpath: "",
            epbPaperPath: res?.data?.refId,
            stateCode: "S04",
            constType: "AC",
            constNo: 1,
          }).then(() => {refetch();
window.scrollTo(0,0);});
        });
      }
    });

    setShowConfirmationPopup(false);
  };

  return (
    <div className="container my-2 RO">
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={() => {
            setShowConfirmationPopup(false);
          }}
          size="500px"
          closeIcon={false}
          modalTitle={"Do you want to finalize ?"}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={() => {
                setShowConfirmationPopup(false);
              }}
              yesOption={finalizeEpb}
            />
          }
        />
      }
      {/* <RoundCard> */}
      <div className="box">
        <div className="ml-2 mr-2">
          <h6 style={{ textAlign: "center" }}>Finalize e-PB</h6>
        </div>
        <div className=" ml-2 mr-2 ">
          <RunnerUpHeaderNew title={"Preview e-PB"}
          state={ <span
                 
                  >
                      State: {AcWiseVoterData?.state}{" "}
                    <span style={{marginLeft: "13px"}}></span>Constituency : {AcWiseVoterData?.constituencyNumber}
                    {""} - 
                    {AcWiseVoterData?.constituencyName} -{" "}
                    {AcWiseVoterData?.constituencyType}
                  </span>}
              />
        </div>
        <div className="pdf-view">
          <iframe width="100%" height="500px" src={pdf}></iframe>
        </div>
        <div
          className="button-row ml-2"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getEpbDetails?.payload?.epbPaperFlag !== "Y" &&
            getEpbDetails?.payload?.ballotPaperPath !== null && (
              <Link
                to={""}
                className="button-linkfinalize"
                onClick={() => setShowConfirmationPopup(true)}
              >
                {FINALIZE_EPB}
              </Link>
            )}
          {/* <Button value='Finalize e-pb' onClick={()=>} btnClass='btn-class ml-0' /> */}
        </div>
      </div>

      {/* </RoundCard> */}
    </div>
  );
};

export default Finalizeepb;
